import React from "react";
import Layout from "./components/Layout";

const Main = () => {
    const today = new Date();
    const future = new Date(today);
    future.setDate(today.getDate() + 365);

    const [couponData, setCouponData] = React.useState({});

    const [coupons, setCoupons] = React.useState([
        {
            topNote: "Good for one morning of",
            title: "Breakfast in Bed",
            description:
                "Freshly made with love, served with kisses, and absolutely no dishes for you 💛",
            validUntil: future.toISOString().split("T")[0]
        },
        {
            topNote: "Redeem for one evening of",
            title: "Movie Night",
            description: "Your pick. Snacks included. Phones ignored.",
            validUntil: future.toISOString().split("T")[0]
        }
    ]);

    function addCoupon() {
        setCoupons(prev => [
            ...prev,
            {
                title: "Coupon Text",
                topNote: "",
                description: "",
                validUntil: ""
            }
        ]);
    }

    function removeCoupon(indexToRemove) {
        setCoupons(prev => {
            const newCoupons = prev.filter((_, index) => index !== indexToRemove);

            // setCurrentIndex(prevIndex => {
            //     const maxIndex = newCoupons.length - 1;
            //     if (prevIndex > maxIndex) return maxIndex >= 0 ? maxIndex : 0;
            //     return prevIndex;
            // });

            return newCoupons;
        });
    }

    React.useEffect(() => {
        setCouponData({
            theme: "minimal",
            title: "Love Coupons",
            subtitle: "Redeemable for joy, comfort, and affection",
            redeemable_by: "Alex 💛",
            from: "Jemimah",
            handwritten: false
        });
    }, []);

    const handleCouponDataChange = (k, v) => {
        setCouponData(prevData => ({
            ...prevData, [k]: v
        }));
    }

    function handleCouponRewardChange(i, k, v) {

        setCoupons(prev => {
            const updated = [...prev];

            updated[i] = {
                ...updated[i],
                [k]: v
            };

            return updated;
        });
    }

    return (
        <Layout
            header="Create Personalized Coupons"
            description="Welcome! We'll help you create personalized printable coupons and custom coupon books for birthdays, holidays, anniversaries, and special occasions."
            name="COUPON" data={coupons} addData={addCoupon} handleDataChange={handleCouponRewardChange}
            removeData={removeCoupon} inputData={couponData} handleInputDataChange={handleCouponDataChange}
            optional={{ createNew: true, newButtonText: "COUPON" }}
            styles={["minimal", "playful", "romantic", "luxury"]} />
    )
}

export default Main;